import {
  GetConnectedIntegrationsResponseSchema,
  type GetConnectedIntegrationsResponse,
} from '@vy/api-definition';
import type { QueryClient } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

async function connectedIntegrationsQuery() {
  const api = getPrivateApi();
  const getConnectedIntegrations = await api.getConnectedIntegrations();

  return GetConnectedIntegrationsResponseSchema.parse(getConnectedIntegrations);
}

export function useConnectedIntegrations(options?: CustomUseQueryOptions<GetConnectedIntegrationsResponse>) {
  return useQuery(queryKeys.connectedIntegrations(), connectedIntegrationsQuery, {
    ...options,
  });
}

export async function prefetchConnectedIntegrations(queryClient: QueryClient) {
  await queryClient.prefetchQuery(queryKeys.connectedIntegrations(), connectedIntegrationsQuery);
}
